import {Toast, ToastSeverityType, ToastMessageType} from "primereact/toast";
import React, {useEffect, useRef} from "react";
import { ToastSeverity } from "utils/enums";

const GLOBAL_ALERT_EVENT_NAME = "EasasGlobalAlertEvent"


export default function EasasGlobalAlerts() {
    const toastRef = useRef<Toast>(null);

    useEffect(() => {
        const listener = (e: EasasGlobalAlertEvent) => {
            toastRef.current?.replace({
                severity: e.detail?.type ?? 'info',
                summary: e.detail?.message,
                detail: e.detail?.detail,
                life: 6000,
            });
        };

        window.addEventListener(GLOBAL_ALERT_EVENT_NAME, listener as EventListener);
        return () => window.removeEventListener(GLOBAL_ALERT_EVENT_NAME, listener as EventListener);
    }, []);

    return <Toast ref={toastRef} style={{ zIndex: '1000', top: '60px' }}/>
}


export function easasErrorAlert(message: string, detail?: string) {
    dispatchEvent(new EasasGlobalAlertEvent({message, detail, type: 'error'}))
}
export function easasAlert(message: string, detail?: string, type: ToastSeverityType = 'info') {
    dispatchEvent(new EasasGlobalAlertEvent({message, detail, type}))
}

class EasasGlobalAlertEvent extends CustomEvent<EasasGlobalAlertEventDetail> {
    constructor(msg: EasasGlobalAlertEventDetail) {
        super(GLOBAL_ALERT_EVENT_NAME, { detail: msg });
    }
}

interface EasasGlobalAlertEventDetail {
    message: string,
    detail?: string,
    type: ToastSeverityType,
}

